
/**
* Licensed Materials - Property of IBM
* IBM Cognos Products: ba-dashboard-livewidget
* (C) Copyright IBM Corp. 2018, 2021
* US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
*/
define({
	'pinLabel': 'Vastzetten',
	'find_label': 'Zoeken',
	'findCancelLabel': 'Annuleren',
	'dataPaneLabel': 'Gegevens',
	'sourcePaneLabel': 'Geselecteerde bronnen',
	'sourcePaneContentLabel': 'Selecteer een bron',
	'emptySourcePaneTitle': 'Selecteer een bron',
	'emptySourcePaneCaption': 'Klik op een bron om gegevens toe te voegen die u wilt gebruiken voor het bouwen van een dashboard.',
	'addDataSource': 'Selecteer een bron',
	'addDataDashboardCoachMarkContents': 'Sleep gegevens vanuit het gegevensscherm naar uw dashboard.',
	'addDataStoryCoachMarkContents': 'Sleep gegevens vanuit het gegevensscherm naar uw story.',
	'addDataCoachMarkTitle': 'Gegevens toevoegen',
	'selectSourcesText': 'Selecteer een gegevensbron en voeg hem toe om uw %{app} te bouwen.',
	'selectSourcesLabel': 'Selecteer een bron',
	'errorSourcesTitle': 'Laden van gegevensstructuur is mislukt',
	'errorLoadingDataSources': 'Er is een fout opgetreden bij het laden van de lijst van gegevenssets',
	'errorLoadingDataTree': 'Fout bij het laden van de structuur',
	'dataSetPaneLastUpdated': 'Laatst bijgewerkt: %{date}',
	'dataSourcePaneDateUnknown': 'Onbekend',
	'moreTitle': 'Meer',
	'backLabel': 'Teruggaan',
	'addDataSourceDialogTitle': 'Selecteer een bron',
	'addDataSourceDialogButtonLabel': 'Toevoegen',
	'dlg_use': 'Gebruiken',
	'dlg_RelinkDataSourceTitle': 'Gegevensset "%{dataSourceName}" vervangen door ...',
	'propertiesDialogTitle': 'Eigenschappen',
	'loadingMetadata': 'Metagegevens worden geladen',
	'missingDataSetData': 'De gegevens voor deze gegevensset zijn niet beschikbaar. Vernieuw de gegevensset of vraag de beheerder om toegang tot de bron.',
	'errorLoadingSource': 'De metagegevens voor "%{sourceName}" zijn niet geladen. Neem contact op met de beheerder voor meer informatie.',
	'errorMessageTitle': 'Fout',
	'calculation_navigation_in_use': 'Door het wissen van berekeningen, filters of navigatiepaden worden alle visualisaties waarnaar de gewiste items verwijzen, ongeldig. Weet u zeker dat u het wissen wilt doorzetten?',
	'delete_confirm': 'Wissen bevestigen',
	'previewUnavailable': 'De gegevenslade en globale filters zijn niet beschikbaar voor dit pakkettype.',
	'contextualGridTabName': 'Visualisatiegegevens',
	'DATA_TRAY_no_data_text': 'U hebt momenteel geen gegevens',
	'contextualGridMenuLabel': 'Menu Visualisatiegegevens',
	'contextualGridExport': 'Exporteren',
	'nullValueText': 'Null',
	'forecastDetailsTabName': 'Prognose van statistische gegevens',
	'forecastDetailsModelLabel': 'Model',
	'forecastDetailsQualityMetricLabel': 'Nauwkeurigheidsmeetwaarden',
	'forecastDetailsSmoothingCoefLabel': 'Parameters',
	'forecastDetailsDiagnostics': 'Diagnose',
	'forecastDetailsForecastLabel': 'Prognose',
	'forecastDetailsStatusLabel': 'Status',
	'forecastDetailsAccuracyPercentLabel': 'Nauwkeurigheidspercentage',
	'forecastDetailsTrendLabel': 'Trend',
	'forecastDetailsSeasonLabel': 'Seizoensafhankelijkheid',
	'forecastDetailsSeasonalPeriodLabel': 'Seizoensperiode',
	'forecastDetailsAlphaLabel': 'Alfa',
	'forecastDetailsBetaLabel': 'Bèta',
	'forecastDetailsGammaLabel': 'Gamma',
	'forecastDetailsPhiLabel': 'Phi',
	'forecastDetailsMissingCount': 'Ontbrekende aantal',
	'forecastDetailsSeriesLengthLabel': 'Serielengte',
	'forecastDetailsIgnoredPeriods': 'Genegeerde perioden',
	'forecastDetailsTrendStrength': 'Trendsterkte',
	'forecastDetailsSeasonalityStrength': 'Seizoenssterkte',
	'forecastDetailsTimeDeltaUnit': 'Datum/tijd-interval',
	'forecastDetailsNotes': 'Opmerkingen'
});
